<se-fe-modal #modal>
  <div seFeModalContent>{{ config?.message }}</div>
  <se-fe-modal-footer seFeModalFooter [seFeDataFooterButtons]="config?.actions"></se-fe-modal-footer>
</se-fe-modal>
